<template>
  <div class="label-info">
    <Info />
    <div class="label-info-content">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Info } from 'lucide-vue-next'
</script>

<style scoped>
.label-info {
  color: var(--vc-warning);
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
